<template src="./html/events-quiz.html"></template>

<script>
import App from '../App.vue'
import { quizFunctions } from "./functions";
import moreInfoForm from './more-info-form.vue'

const quiz = {
    questions: [{
      text: "What does your ideal online learning tool do?",
      responses: [{
          text: 'Give us the cutting-edge features and functions we need to stay competitive.',
          value: '0'
        },
        {
          text: 'Provide us with the information and insights we need to be as effective as possible.',
          value: '3'
        },
        {
          text: 'Get people engaged with online learning and excited about the doors it can open.',
          value: '2'
        },
        {
          text: 'Offer better ways to tackle challenges with new, improved, and upgraded tools.',
          value: '1'
        }
      ],
      image: require('../assets/Imagineer/ImagineerTypesQuiz_Q1-lockup.png'),
      background_colour: "background-gradient-1",
      line: "color-amethyst-semi-line"
    },
    {
      text: "Which flavor of ice cream would you choose?",
      responses: [{
          text: 'Better question: What’s new?',
          value: '0'
        },
        {
          text: 'Let’s see what the group wants. Maybe we can get a tub and share!',
          value: '2'
        },
        {
          text: 'First, I need to know if there are waffle cones. Also, what’s available in the way of toppings?',
          value: '1'
        },
        {
          text: 'Hang on, hang on. I must assess my options first.',
          value: '3'
        }
      ],
      image: require('../assets/Imagineer/ImagineerTypesQuiz_Q2-lockup.png'),
      background_colour: "background-gradient-2" ,
      line: "color-tourmaline-semi-line"
      },
    {
      text: "Spending all day with data sounds…",
      responses: [{
          text: 'Amazing—no conditions!',
          value: '3'
        },
        {
          text: 'Fun if I get to experiment with a new feature.',
          value: '0'
        },
        {
          text: 'If the information helps staff and learners, it could be rewarding.',
          value: '2'
        },
        {
          text: 'Like a great way to find and fix problems!',
          value: '1'
        }
      ],
      image: require('../assets/Imagineer/ImagineerTypesQuiz_Q3-lockup.png'),
      background_colour: "background-gradient-3", 
      line: "color-malachite-semi-line"
    },
    {
    text: "If time travel was your superpower, how would you use it?",
      responses: [{
          text: 'Go forward. I want to know what challenges lie ahead so we’re ready to solve them.',
          value: '1'
        },
        {
          text: 'Backwards. I have questions about… well, I’ll tell you everything when I have all the answers.',
          value: '3'
        },
        {
          text: 'I’m not sure. I couldn’t be gone too long, though. I must make sure we stay on track.',
          value: '2'
        },
        {
          text: 'To go forward in time and see all the cool technologies and devices that have yet to be invented!',
          value: '0'
        }
      ],
      image: require('../assets/Imagineer/ImagineerTypesQuiz_Q4-lockup.png'),
      background_colour: "background-gradient-4", 
      line: "color-citrine-semi-line"
    },
    {
      text: "What’s the first question that comes to mind when you hear about new releases?",
      responses: [{
          text: 'When can I get it?',
          value: '0'
        },
        {
          text: 'How does it work?',
          value: '3'
        },
        {
          text: 'What will I be able to do new or differently?',
          value: '1'
        },
        {
          text: 'How will it help my team and my learners?',
          value: '2'
        }
      ],
      image: require('../assets/Imagineer/ImagineerTypesQuiz_Q5-lockup.png'),
      background_colour: "background-gradient-5",
      line: "color-amethyst-semi-line"
    },
    {
    text: "You encounter a problem. What’s the first thing you do?",
      responses: [{
          text: 'Check for recent updates that may have contributed to or could help you correct it.',
          value: '0'
        },
        {
          text: 'Gather the group to see what everyone else knows and find a solution.',
          value: '2'
        },
        {
          text: 'Pause to take stock. Do you have all the information you need to unravel and solve it?',
          value: '3'
        },
        {
          text: 'Fix it now and determine if there are steps you can take so it doesn’t crop up again.',
          value: '1'
        }
      ],
      image: require('../assets/Imagineer/ImagineerTypesQuiz_Q6-lockup.png'),
      background_colour: "background-gradient-6" ,
      line: "color-fluorite-semi-line"
    },
    {
    text: "Change isn’t as scary when…",
      responses: [{
          text: 'You’re with a group and are in it together.',
          value: '2'
        },
        {
          text: 'You can understand what’s behind it.',
          value: '3'
        },
        {
          text: 'You know it’s a steppingstone to bigger, better things.',
          value: '0,1'
        }
      ],
      image: require('../assets/Imagineer/ImagineerTypesQuiz_Q7-lockup.png'),
      background_colour: "background-gradient-7",
      line: "color-malachite-semi-line" 
    },
    {
    text: "You’re out for a drive with a friend, and you come to a four-way intersection. What do you do next? ",
      responses: [{
          text: 'Pull out the map and see where each road will take you.',
          value: '3'
        },
        {
          text: 'Look to them and ask if there’s a direction they’d like to go.',
          value: '2'
        },
        {
          text: 'Turn right. You haven’t been this way before!',
          value: '0,1'
        }
      ],
      image: require('../assets/Imagineer/ImagineerTypesQuiz_Q8-lockup.png'),
      background_colour: "background-gradient-8",
      line: "color-citrine-semi-line" 
    },
    {
    text: "What excites you most about online learning? ",
      responses: [{
          text: 'Always pushing the envelope with new technologies, features, and tools to make sure we stay one step ahead.',
          value: '0'
        },
        {
          text: 'Digging deeper to make sure we have the tools we need and will be equipped to overcome obstacles, now and down the road.',
          value: '3'
        },
        {
          text: 'Getting everyone—from leaders to learners—engaged and invested in the journey in front of us.',
          value: '2'
        },
        {
          text: 'Finding ways to work better—whether by using something new or taking a fresh approach to what’s already in our toolbox.',
          value: '1'
        }
      ],
      image: require('../assets/Imagineer/ImagineerTypesQuiz_Q9-lockup.png'),
      background_colour: "background-gradient-9",
      line: "color-amethyst-semi-line" 
    }
  ]
};

const types_content = {

    sections: [
      {
        section_title: 'Technology Imagineer',
        hovered_content: 'Having the latest-and-greatest tools in your toolkit',
        background_colour: 'color-amethyst',
        text_colour: 'd2lWhite',
        image: require('../assets/Imagineer/ImagineerTypesQuiz_Technology Imagineer.png'),
        social_description: 'I\'m a Technology Imagineer! Register for Fusion to find out what Imagineer you are!',
        winner_content: 'You’re all about having   the latest-and-greatest tools in your supply chest. Whether that’s a new piece of hardware, an update that will keep your existing software one step ahead, or an add-on or integration that’s going to make waves—you love being one of the first to see it in action.',
        download_pdf: ''
      },
      {
        section_title: 'Innovation Imagineer',
        hovered_content: 'Finding innovative and better ways to tackle challenges',
        background_colour: 'color-fluorite',
        text_colour: 'd2lWhite',
        image: require('../assets/Imagineer/ImagineerTypesQuiz_Innovation Imagineer.png'),
        social_description: 'I\'m an Innovation Imagineer! Register for Fusion to find out what Imagineer you are!',
        winner_content: 'You’re all about finding new and better ways to tackle the challenges ahead of you. That could mean leveraging a new piece of technology, using an existing piece of gear in a unique way, or rallying people together towards new paths. If it’s a novel or revamped approach, you’re on it.',
        download_pdf: ''
      },
      {
        section_title: 'Engagement Imagineer',
        hovered_content: 'Getting people excited about the journeys ahead',
        background_colour: 'color-malachite-n1',
        text_colour: 'color-onyx',
        image: require('../assets/Imagineer/ImagineerTypesQuiz_Engagement Imagineer.png'),
        social_description: 'I\'m an Engagement Imagineer! Register for Fusion to find out what Imagineer you are!',
        winner_content: 'You’re all about getting people invested in and excited about the journeys they have ahead of them. Sometimes the road will be short and simple. Other times it will be longer and more complex. Whatever lies ahead, your focus is making sure people stay engaged at every step.',
        download_pdf: ''
      },
      {
        section_title: 'Research Imagineer',
        hovered_content: 'Making sure you’re getting the most out of your technology',
        background_colour: 'color-citrine',
        text_colour: 'color-onyx',
        image: require('../assets/Imagineer/ImagineerTypesQuiz_Research Imagineer.png'),
        social_description: 'I\'m a Research Imagineer! Register for Fusion to find out what Imagineer you are!',
        winner_content: 'You’re all about digging deeper to make sure people are getting the most out of their tools, are taking the best possible paths, and aren’t encountering unbeatable roadblocks. This could be giving people confirmation that they’re on the right track or using your insight to suggest alternate routes.',
        download_pdf: ''
      }
    ]
};

export default {
  name: 'fusion-Imagineer-type-quiz',
  components: {
    moreInfoForm
  },
  data() { 
    return this.defaultQuizData()
  },
  mixins: [quizFunctions],
  methods:{
    defaultQuizData: function() {
          return {
        name: 'Imagineer',
        title: 'What type of online learning imagineer are you?',
        share_description: 'Complete this quiz to find out which imagineer you are!',
        active_image_default: require('../assets/Imagineer/ImagineerTypesQuiz_Hero intro.png'),
        active_image: require('../assets/Imagineer/ImagineerTypesQuiz_Hero intro.png'),
        active_section: '-1',
        active_colour_default: 'color-celestine',
        active_colour: 'color-celestine',
        winning_colour: '',
        winning_text_colour: '',
        winning_image: '',
        winning_title: '',
        content_display: '',
        quiz_hidden: true,
        quiz: quiz,
          questionIndex: 0,
          userResponses: Array(),
        homepage_hidden: false,
        types: types_content,
        share_url: 'https://d2l.tkeventsregistration.com/fusion2021_US/',
        showForm: false,
        form_text: 'Fill out the form to get the full story on your imagineer type—your strengths, top tools, and partner in adventure.',
        form_thank_you_message: '',
        button_text: '',
        form_id: '2986',
        salesforce_id: '7015W0000009Jd8QAE',
        asset_redirect: ''
      }
    }
  }
  }



</script>